export default __webpack_public_path__ + "static/media/no-data.77ca2522.png";